module.exports = __webpack_public_path__ + "static/media/img-homefds23-online.2cc43b48.jpg";